import { getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('groups init')
}

export async function list(app, apiHost, pageNo = 1, searchText = '', filters = {}) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`

  // Add searchKey (from filters or searchText param)
  const searchKey = filters.searchKey || searchText
  if (searchKey) {
    URL += `&searchKey=${encodeURIComponent(searchKey)}`
  }

  // Add guid (single) or guids (multiple)
  if (filters.guid) {
    URL += `&guid=${encodeURIComponent(filters.guid)}`
  } else if (filters.guids && Array.isArray(filters.guids) && filters.guids.length > 0) {
    URL += `&guids=${filters.guids.map(g => encodeURIComponent(g)).join(',')}`
  }

  // Add type
  if (filters.type) {
    URL += `&type=${encodeURIComponent(filters.type)}`
  }

  // Add membersCount with operator
  if (
    filters.membersCount &&
    filters.membersCount.operator &&
    filters.membersCount.value !== undefined
  ) {
    URL += `&membersCount[${encodeURIComponent(filters.membersCount.operator)}]=${encodeURIComponent(
      filters.membersCount.value,
    )}`
  }

  // Add createdAt date range
  if (filters.createdAtFrom) {
    URL += `&createdAt[from]=${encodeURIComponent(filters.createdAtFrom)}`
  }
  if (filters.createdAtTo) {
    URL += `&createdAt[to]=${encodeURIComponent(filters.createdAtTo)}`
  }

  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
      },
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      if (error && error.response && error.response.data) return error.response.data
      // else
      return false
      // return error.response.data;
    })
}

export async function add(post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups`
  return axios
    .post(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function get(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${id}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function search(app, apiHost, searchText, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function members(id, app, apiHost, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${id}/members?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchMembers(id, searchText, app, apiHost, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/groups/${id}/members?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function kickMember(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/members/${uid}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function banMember(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/bannedusers/${uid}`
  return axios
    .post(
      `${URL}`,
      {},
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function unbanMember(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/bannedusers/${uid}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getBanMembers(guid, app, apiHost, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/bannedusers?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchBanMembers(guid, searchText, app, apiHost, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/groups/${guid}/bannedusers?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function addMembers(uids, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/members`
  return axios
    .post(
      `${URL}`,
      { participants: uids },
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

// Group Scope Permissions V2 Functions

export async function listGroupScopePermissions(guid, scope, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/groups/${guid}/scopes/${scope}/permissions?includePermissionObject=true`

  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response ? error.response.data : error
    })
}

export async function getGroupScopePermissionsValues(guid, scope, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/scopes/${scope}/permissions`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response ? error.response.data : error
    })
}

export async function updateGroupScopePermissions(guid, scope, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/scopes/${scope}/permissions`
  return axios
    .put(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response ? error.response.data : error
    })
}

export async function resetGroupScopePermission(guid, scope, permissionId, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/groups/${guid}/scopes/${scope}/permissions/${permissionId}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response ? error.response.data : error
    })
}
